import React from 'react';
import { TypeAccountERCTranslations } from '@/utils/translations/types/TypeAccountERCTranslations';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';

export type LayoutProcessingErcSubscriptionProps = {
  t: TypeAccountERCTranslations;
};

function LayoutProcessingErcSubscription({
  t,
}: LayoutProcessingErcSubscriptionProps) {
  return (
    <div data-testid="layoutProcessingErcSubscription" className="px-6 xl:px-0">
      <Heading
        tag={HeadingTag.H1}
        size={HeadingSize.H1}
        text={t.subscriptionProcessingHeader}
        classes="mb-4 md:mb-6"
      />
      <p className="rounded-md p-6 md:p-8 shadow-[0px_4px_8px_0px_rgba(0,0,0,0.16)]">
        {t.subscriptionProcessingMessage}
      </p>
    </div>
  );
}

export default LayoutProcessingErcSubscription;
